import { Badge, Box } from '@chakra-ui/react'
import CustomTooltip from 'BrokerTsLib/src/components/CustomTooltip'
import { OfferStatusEnum } from 'BrokerTsLib/src/enums/offerStatusEnum'

export const StatusBadge = ({ status, tooltip }: { status: OfferStatusEnum, tooltip?: string }) => {
  let colorScheme
  let text

  switch (status) {
    case OfferStatusEnum.Error:
      colorScheme = 'red'
      text = 'Chyba'
      break
    case OfferStatusEnum.Selected:
      colorScheme = 'green'
      text = 'Vybraná'
      break
    case OfferStatusEnum.Valid:
      text = ''
      break
  }

  if (!text)
    return null

  const children = (
    <Badge sx={{ h: 4, py: 0, fontSize: 'xs' }} colorScheme={colorScheme}>
      {text}
    </Badge>)

  return (
    <>
      {!!tooltip &&
        <CustomTooltip
          trigger='clickHover'
          hasArrow
          placement="top"
          boxProps={{
            display: 'flex',
          }}
          label={<Box dangerouslySetInnerHTML={{ __html: tooltip }}></Box>}
        >
          {children}
        </CustomTooltip>
      }

      {!tooltip && children}
    </>
  )
}
